import { JOURNEY_VIEWER } from '../../constants/actionTypes';

const { REQUEST_CONTENTS } = JOURNEY_VIEWER;

export const requestJourneyContents = () => ({
  type: REQUEST_CONTENTS.IN_PROGRESS,
});

export const requestJourneyContentsSuccess = payload => ({
  type: REQUEST_CONTENTS.SUCCESS,
  payload,
});

export const requestJourneyContentsError = error => ({
  type: REQUEST_CONTENTS.ERROR,
  error,
});
